import { GET_ONE, GET_LIST, CREATE } from 'react-admin';
import * as constants from '../../constants/index';
import { GET_RULES, Rule, Airline, SET_RULES, GET_AIRLINES_LIST, GET_AIRLINES_LIST_CLEAR, UPDATE_AIRLINE, UPDATE_AIRLINE_CLEAR } from './types';
const FORM_DATA = 'FORM_DATA';

export const getRules = () => ({
    type: GET_RULES,
    meta: { fetch: GET_ONE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.SYSTEM.GET_RULES}` },
});

export const setRules = (data: Rule, signFile?: any) => ({
    type: SET_RULES,
    meta: { fetch: FORM_DATA, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.SYSTEM.SET_RULES}` },
    payload: { data: { newRules: JSON.stringify(data), signFile } }
});

export const getAirlinesList = () => ({
    type: GET_AIRLINES_LIST,
    meta: { fetch: GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AIRLINE.GET_AIRLINES}` },
});

export const updateAirline = (airlineId: string, updateBody: Airline) => ({
    type: UPDATE_AIRLINE,
    meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AIRLINE.UPDATE_AIRLINE}` },
    payload: { data: { airlineId, updateBody } }
});

export const clearAirlinesList = () => ({
    type: GET_AIRLINES_LIST_CLEAR,
    payload: { data: [] }
});

export const clearUpdateAirline = () => ({
    type: UPDATE_AIRLINE_CLEAR,
    payload: { data: null }
});